/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ComponentBase from "../Utility/ComponentBase";

const ccclass = cc._decorator.ccclass;
const property = cc._decorator.property;

@ccclass("SymbolStack")
export class SymbolStack
{
    @property()
    public StackSymbol: string = "";

    @property()
    public StackLength: number = 0;
}

@ccclass
export default abstract class SymbolSubstitutionBase extends ComponentBase
{
    /**
     * Should this substitution be run on a per-spin basis?
     */
    public abstract get IsContinuous(): boolean;

    /**
     * Substitutes symbols in the provided reel strip.
     * @param reelStrip - The reel strip to run the substitution on.
     * @returns The substituted reel strips.
     */
    public abstract SubstituteReelSymbols(reelStrip: string[], reelIndex: number): string[];
}